<template>
  <div class="date-picker">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-left="50"
      transition="scale-transition"
      offset-y
      min-width="auto"
      :disabled="disabled"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="inputDate"
          :label="dateLabel"
          append-icon="mdi-calendar"
          :outlined="outlined"
          :dense="dense"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="inputDate"
        scrollable
        :locale="locale"
        :min="minDate"
        :disabled="disabled"
        @input="menu = false"
      ></v-date-picker>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: "DatePicker",
  props: {
    date: {
      type: String
    },
    "date-label": {
      type: String
    },
    "date-rules": {
      type: Array
    },
    "min-date": {
      type: String
    },
    locale: {
      type: String
    },
    outlined: {
      type: Boolean
    },
    dense: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    inputDate: {
      get() {
        return this.date;
      },
      set(val) {
        this.$emit("update:date", val);
      }
    }
  },
  data() {
    return {
      menu: false
    };
  }
};
</script>
